import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as R from "ramda"
import { useAppDispatch } from '../../../../../../hooks/hooks';
import { selectProjectsQueryItems } from '../../../../../../redux/projects/selector';
import { projects } from '../../../../../../redux/projects/action';
import PageLoader from '../../../../../../components/PageLoader';
import ProjectComponent from '../components/project.component';

const ProjectContainer= () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const queryItems = useSelector(selectProjectsQueryItems)
  const [isLoading, setIsLoading] = useState<boolean>(true)
const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    selectedProject,
    setSelectedProject
  ] = useState<any>([])
 
  const fetchProjectsById= ()=>{
    dispatch(projects.query({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/service/psa/projects/query`,entity:'projects',jsonData:{
          
    Records: [
      {
        
          
              "Id": parmas?.id
          
      
       
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})




  }

  const handleInnerFormChange: any = (event: any, field: string) => {
    setSelectedProject({ ...selectedProject, [field]: event });
  }

  const handleFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setSelectedProject({ ...selectedProject, [fields[0]]: value });
  }
  useEffect(
    () => {
      if (parmas?.id > 0) {
        fetchProjectsById()
        setIsLoading(false)
      }
      else{
        setIsLoading(false)
      }
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedProject(queryItems?.result?.items)
      }
    },
    [isQuery]
  )
 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    if (parmas?.id > 0) {
      await dispatch(projects.resetAction({ actionType: 'update' }))
     await dispatch(projects.update({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/service/psa/projects`,entity:'Projectss',jsonData:{
          
    Records: [
      
        
       

       selectedProject
    
    
      
    ]
 
}})).then(()=>{
  back()
})

    }else{
      await dispatch(projects.resetAction({ actionType: 'create' }))
      await dispatch(projects.create({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/service/psa/projects`,entity:'projects',jsonData:{
          
      Records: [selectedProject
        
      ]
    
  }})).then(()=>{
    back()
  })
    }

  }

const back=()=>{
  navigate('/csg-portal/service/psa/projects')
} 

    return (
    <>
       {isLoading ? <PageLoader /> : 
          <ProjectComponent 
           handleInnerFormChange={handleInnerFormChange}
           selectedProject={selectedProject}
           back={back}
           handleFormSubmit={handleFormSubmit}
           handleFormChange={handleFormChange}
          /> 
    } 
          </>
    )
    
    }
   
    export default ProjectContainer;
